// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/template.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { templatesApi } from "../../api/templates";
import type { Template } from "../../api/types";
// override-block:imports BEGIN
import type { TemplateStatus, TemplateTone } from "../../api/types";
// CHG-1294 — per-page RBAC gate wiring (consumes GATE_CATALOG).
import { GATE_CATALOG } from "../../auth/gateCatalog";
import { toGate } from "../../auth/toGateProp";
// override-block:imports END

// override-block:helpers BEGIN
const STATUS_LABEL: Record<TemplateStatus, string> = {
  draft: "Draft",
  published: "Published",
  archived: "Archived",
};
const TONE_LABEL: Record<TemplateTone, string> = {
  warm: "Warm",
  urgent: "Urgent",
  celebratory: "Celebratory",
  concerned: "Concerned",
  grateful: "Grateful",
};
// override-block:helpers END

export const templateListConfig: ListPageConfig<Template> = {
  title: "Templates",
  subtitle: "Notification templates — email, SMS, and in-app messages.",
  queryKey: ["templates", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search }) =>
    templatesApi.listTemplates({ page, pageSize, sortField, sortDirection, search }),
  defaultSort: { field: "updated_at", direction: "desc" },
  pageSize: 50,
  rowHref: "/templates/{id}",
  search: { enabled: true, placeholder: "Search templates by name, purpose, or tone…" },
  emptyState: {
    title: "No templates yet",
    subtitle: "Create your first template to start sending branded notifications.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    { id: "edit", label: "Edit", variant: "secondary", permissionGate: toGate(GATE_CATALOG.template_list["edit"], "disable") },
    { id: "duplicate", label: "Duplicate", variant: "ghost", permissionGate: toGate(GATE_CATALOG.template_list["duplicate"], "hide") },
    // override-block:header-actions END
  ],
  columns: [
    { field: "name", label: "Name", type: "text", sortable: true },
    { field: "purpose", label: "Purpose", type: "text", sortable: true },
    // override-block:column-tone BEGIN
    {
      field: "tone",
      label: "Tone",
      type: "custom",
      render: (row) => TONE_LABEL[row.tone] ?? row.tone,
    },
    // override-block:column-tone END
    // override-block:column-status BEGIN
    {
      field: "status",
      label: "Status",
      type: "custom",
      render: (row) => STATUS_LABEL[row.status] ?? row.status,
    },
    // override-block:column-status END
    { field: "current_version", label: "Version", type: "text" },
    { field: "updated_at", label: "Updated", type: "relative-date", sortable: true },
  ],
};
